var selectedClient = window.localStorage.getItem(`defaultUser`);
var selectedDate = window.localStorage.getItem(`defaultDate`)

export const ISOEDC_GrossMarginVolume = `query getMonthlyData {
	getMonthlyData(client:"${selectedClient}", id: "${selectedDate}") {
		iso
    	type
  	edcs {
      name
      values {
        year
        values {
          month
          value
        }
      }
    }
    }
}`;
